<template>
  <div>
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">选择标签</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img class="none" />
      </div>
    </div>

    <div class="tag-block">


      <div class="block">
        <span class="key">女生标签：</span>
        <div class="item ub ub-pc flexWrap">
          <span class="tag" :class="ary_tag.indexOf(item)>-1 ? 'tag-on' : ''" v-for="(item, index) in girl_tag_ary" :key="index" @click="item_click(item)">{{item}}</span>
        </div>
      </div>

      <div class="block">
        <span class="key">男生标签：</span>
        <div class="item ub ub-pc flexWrap">
          <span class="tag" v-for="(item, index) in boy_tag_ary" :key="index" @click="item_click(item)">{{item}}</span>
        </div>
      </div>


      <div class="block">
        <span class="key">已选：</span>
        <div class="item ub ub-pc flexWrap">
          <span
            class="tag-on ub ub-pc"
            v-for="(t, index) in ary_tag"
            :key="index"
            @click="remove_tag(t)"
            >{{ t }}<img src="../../assets/img/关闭.png" class="close-img"
          /></span>
        </div>
      </div>


       <div class="block">
        <span class="key">自定义：</span>
        <div class="ub ub-pc tag-txt">
          <input
            type="text"
            v-model="tag"
            placeholder="请输入自定义标签"
            class="input-verify"
          />
          <span class="add-tag" @click="self_tag()">添加</span>
        </div>
        <div class="item ub ub-pc flexWrap"></div>
      </div>


    </div>

    <div class="ub ub-ac" style="padding: 0 .8em;">
      <div class="ub ub-ac ub-pc submit-btn" @click="save_tag()">下一步</div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      tag: "",
      girl_tag_ary:["小猫咪罢了","温柔哄睡","情感咨询","有趣的灵魂","小话唠","奶声奶气","jk女孩","倾听","游戏技术陪玩","大长腿","舔狗","任性","友善","热情","暴脾气","御姐","小红帽","宅女","诡诈精"],
      boy_tag_ary:["小猫咪罢了","温柔哄睡","情感咨询","有趣的灵魂","小话唠","奶声奶气","jk女孩","倾听","游戏技术陪玩","大长腿","舔狗","任性","友善","热情","暴脾气","御姐","小红帽","宅女","诡诈精"],
      ary_tag: ["温柔哄睡", "有趣的灵魂", "小话唠", "jk女孩", "倾听"],
    };
  },
  mounted() {
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page() {
      var uid = this.$store.state.uid;
      var self = this;
      this.$loading("加载...");
      setTimeout(() => {
        self.$loading.close();
      }, 5000);
      self.get({
        url: "/App/Get_Play_Data_One/?uid=" + uid,
        success: function (data) {
          self.$loading.close();
          if (data.tags) {
            self.ary_tag = data.tags.split(",");
          }
        },
      });
    },

    item_click(tag){
      this.add_tag(tag)
    },

    self_tag(){
      var tag = this.tag;
      this.tag = "";
      if (tag == "") {
        this.$toast.top("请输入标签");
        return false;
      }
      this.add_tag(tag);
    },

    add_tag(tag) {
      if (this.ary_tag.length >= 6) {
        this.$toast.top("最多只能设置6个标签");
        return false;
       }

      this.ary_tag.push(tag);
    },

    remove_tag(tag) {
      for(var i=0; i<this.ary_tag.length;i++){
        if(tag==this.ary_tag[i]){
          this.ary_tag.splice(i, 1);
          break;
        }
      }

    },
    save_tag() {
      var uid = this.$store.state.uid;
      var self = this;
      var data_send = {
        tags: this.ary_tag.join(","),
      };
      var strsend = JSON.stringify(data_send);
      this.post({
        url: "/App/Update_User_Play",
        data: { uid: uid, data: strsend },
        success: function (serve_data) {
          console.log(JSON.stringify(serve_data));
          if (serve_data.state == "1") {
            self.$router.push({ name: "play_apply5" });
          }
        },
      });
    },

  },
};
</script>

<style scoped>
.tag-block {
  padding: 0.8em;
}
.block {
  margin-bottom: 2em;
}
.key {
  font-size: 0.95em;
  color: #333;
  font-weight: bold;
  width: 5em;
}
.item {
  margin-top: 0.5em;
}
.tag {
  padding: 0.2em 0.5em;
  border: 1px solid #959596;
  border-radius: 1em;
  font-size: 0.8em;
  color: #959596;
  margin: 0.5em 0.3em;
}

.tag-on {
  padding: 0.2em 0.5em;
  border: 1px solid #e92162;
  border-radius: 1em;
  font-size: 0.8em;
  color: #e92162;
  margin: 0.5em 0.3em;
}

.input-verify {
  background-color: transparent;
  margin-left: 0.3em;
  border: 0;
  outline: 0;
  width: 100%;
  font-size: 0.95em;
  margin-top: 0.3em;
}
.tag-txt {
  border: 1px solid #e92162;
  border-radius: 0.6em;
  margin-top: 0.8em;
}
.close-img {
  width: 1.1em;
  margin-left: 0.2em;
}
.add-tag {
  width: 3em;
  padding: 0.3em 0.5em;
  border: 1px solid #e92162;
  background-color: #e92162;
  color: #fff;
  border-radius: 0.5em;
  text-align: center;
}
.submit-btn {
  width: 100%;
  height: 2.3em;
  line-height: 2.3em;
  border-radius: 1.15em;
  background-color: #fc568c;
  margin-top: .5em;
  color: #fff0f4;
}
</style>
